import { Button, Flex } from 'pcln-design-system';
import React, { useContext, useState } from 'react';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import styled from 'styled-components';
import analytics from './analytics/analytics';
import { useStandaloneStyles } from './context/StandaloneStyleContext';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "QuickActions__StyledFlex",
  componentId: "sc-q8r406-0"
})(["overflow-x:auto;", " ", ""], ({
  isStandalone
}) => isStandalone && `
      width: fit-content;
      white-space: nowrap;
      flex-wrap: wrap;
      max-width: 100%;
    `, ({
  isSingleLine
}) => isSingleLine && `
      width: 100%;
      position: absolute;
      flex-wrap: nowrap;
      height: 91px;
    `);
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "QuickActions__StyledButton",
  componentId: "sc-q8r406-1"
})(["white-space:nowrap;"]);
/**
 * QuickActions component renders a row of quick action buttons that users can click to trigger predefined actions
 * @internal
 *
 * @returns JSX.Element
 */
export const QuickActions = props => {
  const {
    submitQuickActionMessage,
    hasOtherMessage,
    quickActions,
    isSeparatorMsg,
    isSingleLine,
    alignItems = 'center',
    isStandalone,
    onScroll
  } = props;
  const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = useState(true);
  const {
    quickActionsContainer
  } = useStandaloneStyles();
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  if (!isSeparatorMsg && (!quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) {
    return null;
  }
  return React.createElement(StyledFlex, Object.assign({
    onScroll: onScroll,
    isStandalone: isStandalone,
    isSingleLine: isSingleLine
  }, quickActionsContainer, {
    flexDirection: 'row',
    alignItems: alignItems,
    pb: 2,
    "data-testid": 'quick-actions-container'
  }), quickActions.map((action, i) => React.createElement(Flex, {
    key: `quick-action-button-${i}`,
    my: 2,
    mx: 1,
    alignItems: 'center'
  }, React.createElement(StyledButton, {
    boxShadowSize: 'sm',
    variation: 'white',
    onClick: function () {
      setQuickActionsDisplayedValue(false);
      analytics.log({
        label: 'quickActions',
        message: 'QUICK_ACTION_BUTTON_CLICKED',
        content: action.label
      });
      submitQuickActionMessage(action);
    },
    width: isMobile ? 1 : ''
  }, action.label))));
};